import CenteredWrapper from "../../components/CenteredWrapper";
import { keys } from "../../constant/keyConfig";
import { useUserContext } from "../../context/userGetContext";
import useQuery from "../../hooks/useQuery";
import { getLoader } from "../../utils/common";
import AddFromStorage from "./components/AddFromStorage";
import BrowserStorage from "./components/BrowserStorage";
import TeamsContextProvider from "./TeamsContextProvider";

function RootNavigator() {
  const teamsContext = useUserContext();
  const { loadingTeamsContext, errorTeamsContext } = teamsContext;
  const query = useQuery();
  const addAccountQuery = query.get(keys.ADD_ACCOUNT);
  if (loadingTeamsContext) {
    return <CenteredWrapper>{getLoader(teamsContext?.theme)}</CenteredWrapper>;
  }
  if (errorTeamsContext && addAccountQuery) {
    return (
      <CenteredWrapper>
        <AddFromStorage />
      </CenteredWrapper>
    );
  }
  if (errorTeamsContext) {
    return (
      <CenteredWrapper>
        <BrowserStorage />
      </CenteredWrapper>
    );
  }

  return <TeamsContextProvider />;
}

export default RootNavigator;
